import React, { Component } from "react";
import {
  Paper,
  TableCell,
  Table,
  TableHead,
  TableRow,
  Button,
  TableBody,
} from "@material-ui/core";
import InputFormat from "../../../partials/inputForm";
import { style } from "./styles";
import { translate } from "react-i18next";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import { withStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import CheckIcon from "@material-ui/icons/Check";
class Attribute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: this.props.product || {},
      newAttributeName: "",
      newAttributeValue: "",
      addNewAttribute: false,
      editIndex: -1,
      editAttribute: {},
    };
  }
  async componentDidMount() {
    this.setState({ product: this.props.product || {} });
  }
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.product && nextProps.product.id !== this.state.product.id)
      this.setState({
        product: nextProps.product,
      });
  };
  handleChangeAttribute = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let state = this.state;
    state[name] = value;
    this.setState(state);
  };
  handleEditAttribute = (index, attribute) => {
    this.setState({
      editIndex: index,
      editAttribute: attribute,
      backupEdit: { ...attribute },
    });
  };
  changeEdit = (property, value) => {
    let { editAttribute } = this.state;
    editAttribute[property] = value;
    this.setState({ editAttribute });
  };
  handleDiscardAttribute = (index) => {
    let { product, backupEdit } = this.state;
    let attributes = product.attributes || [];
    attributes[index] = backupEdit;
    this.setState({ editIndex: -1, editAttribute: {}, product: product });
  };
  newRecord = () => {
    this.setState({
      addNewAttribute: true,
      newAttributeName: "",
      newAttributeValue: "",
    });
  };
  handleAddNewAttribute = () => {
    let { product, newAttributeName, newAttributeValue } = this.state;
    let attributes = product.attributes || [];
    attributes.push({
      name: newAttributeName,
      value: newAttributeValue,
    });
    this.setState({
      product: product,
      addNewAttribute: false,
      newAttributeName: "",
      newAttributeValue: "",
    });
  };
  handleDeleteAttribute = (index) => {
    let { product } = this.state;
    product.attributes.splice(index, 1);
    this.setState(product);
  };
  handleUpdateAttribute = (index) => {
    let { product, editAttribute } = this.state;
    let attributes = product.attributes || [];
    attributes[index] = editAttribute;
    this.setState({ editIndex: -1, editAttribute: {}, product: product });
  };
  render() {
    const { classes, t } = this.props;
    let {
      addNewAttribute,
      newAttributeName,
      newAttributeValue,
      product,
    } = this.state;
    let attributes = product.attributes || [];
    return (
      <Paper className={classes.container}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              {/* <TableCell>Sku</TableCell> */}
              <TableCell align="left">{t("product_attribute_name")}</TableCell>
              <TableCell align="left">{t("product_attribute_value")}</TableCell>
              <TableCell align="left"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {attributes.map((row, index) => {
              if (index === this.state.editIndex) {
                return (
                  <TableRow>
                    <TableCell align="left" component="th" scope="row">
                      <InputFormat
                        variant="standard"
                        value={row.name}
                        onChange={(e) =>
                          this.changeEdit("name", e.target.value)
                        }
                      />
                    </TableCell>
                    <TableCell align="left" component="th" scope="row">
                      <InputFormat
                        variant="standard"
                        value={row.value}
                        onChange={(e) =>
                          this.changeEdit("value", e.target.value)
                        }
                      />
                    </TableCell>
                    <TableCell align="left">
                      <IconButton
                        aria-label="edit"
                        onClick={() => this.handleUpdateAttribute(index)}
                      >
                        <CheckIcon />
                      </IconButton>
                      <IconButton
                        aria-label="edit"
                        onClick={() => this.handleDiscardAttribute(index)}
                      >
                        <CloseIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              }
              return (
                <TableRow key={row.name}>
                  <TableCell align="left" component="th" scope="row">
                    {row.name}
                  </TableCell>
                  <TableCell align="left">{row.value}</TableCell>
                  <TableCell align="left">
                    <IconButton
                      aria-label="edit"
                      onClick={() => this.handleDeleteAttribute(index)}
                    >
                      <DeleteIcon />
                    </IconButton>
                    <IconButton
                      aria-label="edit"
                      onClick={() => this.handleEditAttribute(index, row)}
                    >
                      <EditIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
            {addNewAttribute && (
              <TableRow>
                <TableCell align="left" component="th" scope="row">
                  <InputFormat
                    variant="standard"
                    // label="New tag name"
                    name="newAttributeName"
                    value={newAttributeName}
                    onChange={this.handleChangeAttribute}
                  />
                </TableCell>
                <TableCell align="left">
                  <InputFormat
                    variant="standard"
                    // label="New tag name"
                    name="newAttributeValue"
                    value={newAttributeValue}
                    onChange={this.handleChangeAttribute}
                  />
                </TableCell>
                <TableCell align="left">
                  <IconButton aria-label="edit">
                    <AddIcon onClick={() => this.handleAddNewAttribute()} />
                    {/* <DeleteIcon /> */}
                  </IconButton>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <div className={classes.buttonContainer}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => this.newRecord()}
          >
            {t("product_add_new_attribute")}
          </Button>
        </div>
      </Paper>
    );
  }
}
export default translate("translations")(
  withStyles(style, { withTheme: 0 })(Attribute)
);
